<template>
  <HomePageCard class="platform-notices" :title="title" extra="更多" @extraClick="$emit('extraClicked')">
    <ul class="notice-list">
      <NoticeItem v-for="noticeItem in notices" :key="noticeItem.id" :isNew="noticeItem.isNew" :name="noticeItem.name" @itemClicked="noticeClicked(noticeItem.id)" :date="noticeItem.date" />
    </ul>
  </HomePageCard>
</template>
<script>
  import HomePageCard from "components/homepage/Card.vue";
  import NoticeItem from "components/homepage/noticeItem.vue";
  import { getNoticeDetailUrl } from "utils/notices";
  export default {
      components: { HomePageCard, NoticeItem },
      props: {
          title: {
              type: String,
              required: true
          },
          notices: {
              type: Array,
              required: true
          }
      },
      methods: {
          noticeClicked(id) {
              window.open(getNoticeDetailUrl(id), "_blank");
          }
      }
  };
</script>
<style lang="postcss">
.platform-notices {
  flex: 1 0 100%;
  height: 252px;
  overflow: hidden;
  margin-bottom: 20px;
  .tbo-card-body {
    padding: 0 20px 20px 20px !important;
  }
  .notice-list {
    list-style-type: none;
  }
}
</style>



// WEBPACK FOOTER //
// notices.vue?859e3888